import SmoothScroll from '../singleton/SmoothScroll';

export default class Header {
  constructor() {
    this.navState = false;
    this.lastScrollTop = 0;
    this.refreshRefs();
    this.bindScrollListener();
    this.bindInPageLinks();
  }

  refreshRefs() {
    this.$header = $('.page-header');
    this.$nav = $('.nav');
    this.navState = false;
  }

  get$header() {
    return this.$header;
  }

  bindScrollListener() {
    SmoothScroll.scroll?.on('scroll', this.onScroll.bind(this));
  }

  bindEvents() {
    $('.hamburger').off('click.header').on('click.header', () => {
      if (this.navState) {
        this.$header.removeClass('is-opened');
        this.$nav.removeClass('is-opened');
        SmoothScroll.enableScrolling();
      } else {
        this.$header.addClass('is-opened');
        this.$nav.addClass('is-opened');
        SmoothScroll.disableScrolling();
      }

      this.navState = !this.navState;
    });

    document.body.addEventListener('mousedown', () => {
      document.body.classList.remove('is-tab');
    });

    document.body.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') {
        document.body.classList.add('is-tab');
      }
    });

    this.bindImageLoadRefresh();
  }

  bindInPageLinks() {
    $(document).off('click.smoothScroll', 'a[href^="#"]');
    $(document).on('click.smoothScroll', 'a[href^="#"]', (event) => {
      const href = $(event.currentTarget).attr('href');

      if (!href || href === '#') {
        return;
      }

      const $target = $(href);

      if (!$target.length) {
        return;
      }

      event.preventDefault();

      if (this.navState) {
        this.$header.removeClass('is-opened');
        this.$nav.removeClass('is-opened');
        SmoothScroll.enableScrolling();
        this.navState = false;
      }

      SmoothScroll.scrollToSection($target);
    });
  }

  bindImageLoadRefresh() {
    const $images = $('img');

    if (!$images.length) {
      return;
    }

    $images.each((i, img) => {
      if (img.complete) {
        SmoothScroll.scheduleRefresh();
      } else {
        img.addEventListener('load', () => SmoothScroll.scheduleRefresh());
      }
    });
  }

  onScroll() {
    const st = SmoothScroll.getScrollTop();

    if (st > this.lastScrollTop) {
      if (st > 50) {
        this.$header.addClass('is-scrolling');
      }
    } else {
      this.$header.removeClass('is-scrolling');
    }

    this.lastScrollTop = st <= 0 ? 0 : st;
  }
}
